import { Route } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';

export const appRoutes: Route[] = [
    { path: '', component: HomeComponent },
    { path: 'impressum', loadComponent: () => import('./legal/impressum/impressum.component').then(m => m.ImpressumComponent) },
    { path: 'datenschutz', loadComponent: () => import('./legal/datenschutz/datenschutz.component').then(m => m.DatenschutzComponent) },
    {
        path: 'blog',
        loadChildren: () =>
            import('./blog/blog.routes').then((m) => m.blogRoutes)
    },
    { path: '**', redirectTo: '' }
];
